import {DetailsFieldsSection} from '@/components/ui/details-atoms/DetailsAtoms'
import styled from 'styled-components'

export const StyledTreatmentRequestDetailsScoresSection = styled(DetailsFieldsSection)`
    border-bottom: none;
`
